import React from 'react';
import PropTypes from 'prop-types';

import Link from 'components/Link';

import css from './DocumentBlock.module.scss';

class DocumentBlock extends React.PureComponent {
    static propTypes = {
        "title": PropTypes.string,
        "readMoreLink": PropTypes.string,
        "readMoreText": PropTypes.string,
        "thumbnailImage": PropTypes.string,
        "pdfLink": PropTypes.string,
        "webcastLink": PropTypes.string,
        "presentationLink": PropTypes.string,
        "pdfLinkText": PropTypes.string,
        "webcastLinkText": PropTypes.string,
        "presentationLinkText": PropTypes.string,
        "xbrlLink": PropTypes.string,
        "xbrlLinkText": PropTypes.string,
        "blockId": PropTypes.number,
        "contentType": PropTypes.string,
    }

    render() {
        const {
            title,
            readMoreLink,
            readMoreText,
            thumbnailImage,
            pdfLink,
            pdfLinkText,
            webcastLink,
            webcastLinkText,
            presentationLink,
            presentationLinkText,
            xbrlLink,
            xbrlLinkText
        } = this.props;

        const hasPdf = pdfLink && pdfLinkText;
        const hasWebcast = webcastLink && webcastLinkText;
        const hasPresentation = presentationLink && presentationLinkText;
        const hasReadMore = readMoreLink && readMoreText;
        const hasXbrlLink = xbrlLink && xbrlLinkText;

        return (
            <div className={css.document}>
                <div className={css.image}>
                    {thumbnailImage && (
                        <img src={thumbnailImage} alt={title ? title : ''} />
                    )}
                </div>
                <div className={css.content}>
                    <h3 className={css.title}>{title}</h3>
                    <ul className={css.links}>
                        {hasPdf && (
                            <li>
                                <Link
                                    className={css.link}
                                    href={pdfLink}
                                    icon="arrow-grey-light-right"
                                    target="_blank"
                                >{pdfLinkText}</Link>
                            </li>
                        )}
                        {hasWebcast && (
                            <li>
                                <Link
                                    className={css.link}
                                    href={webcastLink}
                                    icon="arrow-grey-light-right"
                                    target="_blank"
                                >{webcastLinkText}</Link>
                            </li>
                        )}
                        {hasPresentation && (
                            <li>
                                <Link
                                    className={css.link}
                                    href={presentationLink}
                                    icon="arrow-grey-light-right"
                                    target="_blank"
                                >{presentationLinkText}</Link>
                            </li>
                        )}
                        {hasXbrlLink && (
                            <li>
                                <Link
                                    className={css.link}
                                    href={xbrlLink}
                                    icon="arrow-grey-light-right"
                                    target="_blank"
                                >{xbrlLinkText}</Link>
                            </li>
                        )}
                        {hasReadMore && (
                            <li>
                                <Link
                                    className={css.link}
                                    href={readMoreLink}
                                    icon="arrow-grey-light-right"
                                    download
                                >{readMoreText}</Link>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        );
    }
}

export default DocumentBlock;



// WEBPACK FOOTER //
// ./src/components/DocumentBlock/DocumentBlock.jsx